mutation CreateEmailSequenceTemplateGroup($input: EmailSequenceTemplateGroupCreateInput!) {
    emailSequenceTemplateGroupCreate(input: $input) {
        emailSequenceTemplateGroup {
            id
            name
            position
        }
    }
}
